// src/utils/routeTransitionWarmup.js
// English:
// Schedule route/data warmup after the current input frame.
// This keeps touch navigation responsive on mobile.

import {
  prefetchAddTopicBundle,
  prefetchOwnProfileBundle,
  prefetchPublicProfileBundle,
  prefetchTopicBundle,
} from "./navigationDataPrefetch";

function scheduleWarmup(job) {
  if (typeof window === "undefined") return;

  const run = () => {
    Promise.resolve()
      .then(job)
      .catch(() => {});
  };

  if ("requestAnimationFrame" in window) {
    window.requestAnimationFrame(() => {
      window.setTimeout(run, 0);
    });
    return;
  }

  window.setTimeout(run, 0);
}

export function warmOwnProfileTransition(user = null) {
  scheduleWarmup(() => prefetchOwnProfileBundle(user));
}

export function warmPublicProfileTransition(username = "") {
  scheduleWarmup(() => prefetchPublicProfileBundle(username));
}

export function warmTopicTransition(topicOrWord) {
  scheduleWarmup(() => prefetchTopicBundle(topicOrWord));
}

export function warmAddTopicTransition() {
  scheduleWarmup(() => prefetchAddTopicBundle());
}